import { render } from "./OrderQuestion.vue?vue&type=template&id=02767903"
import script from "./OrderQuestion.vue?vue&type=script&lang=js"
export * from "./OrderQuestion.vue?vue&type=script&lang=js"

import exportComponent from "/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__